


function GuideInfo() {
  return (
    <div
      style={{ overflowY: 'scroll', height: '70vh', color: '#000000', /* margin: '1rem .5rem 1rem 1rem' */ }}
    >
      <h1>寻找资源并下载到电脑</h1>
      <p>浏览器搜索,美剧名称+外挂字幕+阿里云盘,(不一定阿里云盘,只要是视频字幕分离的就好)
        推荐网址
      </p>
      <a href="https://developer.aliyun.com/article/872824">https://developer.aliyun.com/article/872824</a>

      <h1>转换格式</h1>
      <p>
        视频转成mp4格式,用
      </p>
      <a href="https://handbrake.fr/">https://handbrake.fr/</a>
      <p>
        字幕文件转成vtt格式用
      </p>
      <a href="https://www.veed.io/zh-CN/tools/subtitle-converter">https://www.veed.io/zh-CN/tools/subtitle-converter</a>

      <h1>导入手机(ios)</h1>

      <p>
        数据线连接电脑跟手机,电脑使用itunes选择文件共享随便选一个添加文件就好,然后手机就可以看到文件
      </p>

      <img src={require("../../assets/img/图片1.png")} width={'90%'} alt="" />
      <img src={require("../../assets/img/图片2.png")} width={'90%'} alt="" />

      <h1>
        便捷安装
      </h1>
      <p>
        电脑浏览器选择安装应用
      </p>
      <img src={require("../../assets/img/企业微信截图_16865785902189.png")} width={'90%'} alt="" />
      <p>
        手机选择添加应用到主屏幕
      </p>
      <img src={require("../../assets/img/企业微信截图_16865792199696.png")} width={'90%'} alt="" />
      <img src={require("../../assets/img/企业微信截图_16865792331404.png")} width={'90%'} alt="" />
      <h1>
        视频操作
      </h1>
      <img src={require("../../assets/img/企业微信截图_16865790473161.png")} width={'90%'} alt="" />

    </div>
  );
}

export default GuideInfo;